"use strict";
import { __exports as r } from "./index.es466.js";
import { __require as o } from "./index.es445.js";
var i;
function _() {
  return i ? r : (i = 1, (function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "addPathPrefix", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const u = o();
    function n(e, a) {
      if (!e.startsWith("/") || !a)
        return e;
      const { pathname: P, query: d, hash: f } = (0, u.parsePath)(e);
      return "" + a + P + d + f;
    }
  })(r), r);
}
export {
  _ as __require
};
//# sourceMappingURL=index.es398.js.map
